/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import RecognizedNew from './RecognizedNew';

/**
 * The SubjectOfferItem model module.
 * @module model/SubjectOfferItem
 * @version 1.0
 */
class SubjectOfferItem {
    /**
     * Constructs a new <code>SubjectOfferItem</code>.
     * @alias module:model/SubjectOfferItem
     */
    constructor() { 
        
        SubjectOfferItem.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SubjectOfferItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SubjectOfferItem} obj Optional instance to populate.
     * @return {module:model/SubjectOfferItem} The populated <code>SubjectOfferItem</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SubjectOfferItem();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('formative_action_id')) {
                obj['formative_action_id'] = ApiClient.convertToType(data['formative_action_id'], 'Number');
            }
            if (data.hasOwnProperty('abbr')) {
                obj['abbr'] = ApiClient.convertToType(data['abbr'], 'String');
            }
            if (data.hasOwnProperty('order')) {
                obj['order'] = ApiClient.convertToType(data['order'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('subtitle')) {
                obj['subtitle'] = ApiClient.convertToType(data['subtitle'], 'String');
            }
            if (data.hasOwnProperty('grade')) {
                obj['grade'] = ApiClient.convertToType(data['grade'], 'String');
            }
            if (data.hasOwnProperty('recognized')) {
                obj['recognized'] = ApiClient.convertToType(data['recognized'], 'Boolean');
            }
            if (data.hasOwnProperty('approved')) {
                obj['approved'] = ApiClient.convertToType(data['approved'], 'Boolean');
            }
            if (data.hasOwnProperty('is_training_work_center')) {
                obj['is_training_work_center'] = ApiClient.convertToType(data['is_training_work_center'], 'Boolean');
            }
            if (data.hasOwnProperty('is_enrolled')) {
                obj['is_enrolled'] = ApiClient.convertToType(data['is_enrolled'], 'Boolean');
            }
            if (data.hasOwnProperty('enroll_status')) {
                obj['enroll_status'] = ApiClient.convertToType(data['enroll_status'], 'Number');
            }
            if (data.hasOwnProperty('has_compulsory_classes')) {
                obj['has_compulsory_classes'] = ApiClient.convertToType(data['has_compulsory_classes'], 'Boolean');
            }
            if (data.hasOwnProperty('mandatory_compulsory_classes')) {
                obj['mandatory_compulsory_classes'] = ApiClient.convertToType(data['mandatory_compulsory_classes'], 'Boolean');
            }
            if (data.hasOwnProperty('has_done_compulsory_classes')) {
                obj['has_done_compulsory_classes'] = ApiClient.convertToType(data['has_done_compulsory_classes'], 'Boolean');
            }
            if (data.hasOwnProperty('over_percentage_pac')) {
                obj['over_percentage_pac'] = ApiClient.convertToType(data['over_percentage_pac'], 'Boolean');
            }
            if (data.hasOwnProperty('allowed_to_join')) {
                obj['allowed_to_join'] = ApiClient.convertToType(data['allowed_to_join'], 'Boolean');
            }
            if (data.hasOwnProperty('teaching_hours')) {
                obj['teaching_hours'] = ApiClient.convertToType(data['teaching_hours'], 'Number');
            }
            if (data.hasOwnProperty('recognized_new')) {
                obj['recognized_new'] = RecognizedNew.constructFromObject(data['recognized_new']);
            }
            if (data.hasOwnProperty('hidden_grade')) {
                obj['hidden_grade'] = ApiClient.convertToType(data['hidden_grade'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
SubjectOfferItem.prototype['id'] = undefined;

/**
 * @member {Number} formative_action_id
 */
SubjectOfferItem.prototype['formative_action_id'] = undefined;

/**
 * @member {String} abbr
 */
SubjectOfferItem.prototype['abbr'] = undefined;

/**
 * @member {Number} order
 */
SubjectOfferItem.prototype['order'] = undefined;

/**
 * @member {String} title
 */
SubjectOfferItem.prototype['title'] = undefined;

/**
 * @member {String} subtitle
 */
SubjectOfferItem.prototype['subtitle'] = undefined;

/**
 * @member {String} grade
 */
SubjectOfferItem.prototype['grade'] = undefined;

/**
 * @member {Boolean} recognized
 */
SubjectOfferItem.prototype['recognized'] = undefined;

/**
 * @member {Boolean} approved
 */
SubjectOfferItem.prototype['approved'] = undefined;

/**
 * @member {Boolean} is_training_work_center
 */
SubjectOfferItem.prototype['is_training_work_center'] = undefined;

/**
 * @member {Boolean} is_enrolled
 */
SubjectOfferItem.prototype['is_enrolled'] = undefined;

/**
 * @member {Number} enroll_status
 */
SubjectOfferItem.prototype['enroll_status'] = undefined;

/**
 * @member {Boolean} has_compulsory_classes
 */
SubjectOfferItem.prototype['has_compulsory_classes'] = undefined;

/**
 * @member {Boolean} mandatory_compulsory_classes
 */
SubjectOfferItem.prototype['mandatory_compulsory_classes'] = undefined;

/**
 * @member {Boolean} has_done_compulsory_classes
 */
SubjectOfferItem.prototype['has_done_compulsory_classes'] = undefined;

/**
 * @member {Boolean} over_percentage_pac
 */
SubjectOfferItem.prototype['over_percentage_pac'] = undefined;

/**
 * @member {Boolean} allowed_to_join
 */
SubjectOfferItem.prototype['allowed_to_join'] = undefined;

/**
 * @member {Number} teaching_hours
 */
SubjectOfferItem.prototype['teaching_hours'] = undefined;

/**
 * @member {module:model/RecognizedNew} recognized_new
 */
SubjectOfferItem.prototype['recognized_new'] = undefined;

/**
 * @member {Boolean} hidden_grade
 */
SubjectOfferItem.prototype['hidden_grade'] = undefined;






export default SubjectOfferItem;

